import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { GenerateResponseJSON, GetListResponseJSON, RemoveResponseJSON, SftpKeys, SftpPrivateKey } from './key';
import { SelectedSiteService } from '../../selected-site.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class SftpKeyService {
  siteId: string;
  private headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient, private selectedSiteService: SelectedSiteService) {
    this.selectedSiteService.getSiteId().subscribe((siteId: string) => {
      this.siteId = siteId;
    });
  }

  // Builds a request URL with format:

  // Handles a request error
  private static handleError(error: any): Observable<any> {
    return throwError(error.message || error);
  }

  // Get sftp keys for a site
  public getList(): Observable<SftpKeys> {
    const url = this.buildUrl('list');
    return this.http.get(url).pipe(
      map((res: GetListResponseJSON) => SftpKeys.fromJSON(res.data)),
      catchError((err) => SftpKeyService.handleError(err)),
    );
  }

  // Generate key
  public generate(keyName: string, createdBy: string): Observable<SftpPrivateKey> {
    const url = this.buildUrl('generate');
    const data = {
      key_name: keyName,
      created_by: createdBy,
    };
    return this.http.post(url, JSON.stringify(data), { headers: this.headers }).pipe(
      map((res: GenerateResponseJSON) => SftpPrivateKey.fromJSON(res.data)),
      catchError((err) => SftpKeyService.handleError(err)),
    );
  }

  // Remove key
  public remove(keyName: string): Observable<any> {
    const url = this.buildUrl('remove');
    const data = {
      key_name: keyName,
    };
    return this.http.post(url, JSON.stringify(data), { headers: this.headers }).pipe(
      map((res: RemoveResponseJSON) => res.data.key_name),
      catchError((err) => SftpKeyService.handleError(err)),
    );
  }

  // /api/v2/site/<site_id>/sftpkey/<action>/
  private buildUrl(action: string): string {
    return `/api/v2/site/${this.siteId}/sftpkey/${action}/`;
  }
}
